import React from 'react'
import { Route, IndexRoute } from 'react-router'
import Layout from './layout'
import MyProfilePage from './views/my-profile-page'

const Routes = (
  <Route path="my-profile" component={Layout}>
    <IndexRoute component={MyProfilePage} />
  </Route>
)

export default Routes
